import axiosInstance from './config/api';

export const getCallAudio = (callId: string) => {
    return axiosInstance
        .get<ArrayBuffer>(`/workflows/audio/${callId}`, {
            responseType: 'arraybuffer',
            suppressErrorToast: true,
        })
        .then((res) => res.data);
};
